import { CardRadio } from '@/components/ui/CardRadio'
import type { FillPerson } from '@/models/fillApplication'

interface OwnerChoiceListProps {
  owners: FillPerson[]
  selectedId: string | null
  onSelect: (id: string) => void
}

export function OwnerChoiceList({ owners, selectedId, onSelect }: OwnerChoiceListProps) {
  return (
    <div className="flex flex-col gap-2">
      {owners.map((owner) => (
        <CardRadio key={owner.id} isSelected={owner.id === selectedId} onSelect={() => onSelect(owner.id)}>
          <span className="flex flex-col">
            <span>{owner.name || owner.email}</span>
            {owner.name && <span className="text-ink-400 text-sm font-normal">{owner.email}</span>}
          </span>
        </CardRadio>
      ))}
    </div>
  )
}
